import React from 'react';

const Spinner = () => (
  <>
    <style>{`
      @keyframes spinnerSpin {
        0%   { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
      }
    `}</style>

    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      role="status"
      aria-label="Loading"
      style={{
        display: 'inline-block',
        animation: 'spinnerSpin 0.6s linear infinite',
        transformOrigin: 'center'
      }}
    >
      <path
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 
           7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
        fill="currentColor"
        opacity="0.7"
      />
    </svg>
  </>
);

export default Spinner;
